import React from 'react';
import { BookOpen, FileText, CheckSquare, MessageSquare, DollarSign, Globe2 } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const deliverables = [{
  icon: BookOpen,
  title: 'Guía Maestra: El Kit de Supervivencia',
  desc: 'Primer Empleo Remoto (PDF 35+ páginas con el paso a paso exacto).'
}, {
  icon: FileText,
  title: 'Framework de Impacto Cuantificable',
  desc: 'La fórmula exacta para reescribir tus logros y que suenen a resultados.'
}, {
  icon: CheckSquare,
  title: 'Checklist de Auditoría de CV',
  desc: '5 minutos para detectar errores fatales que te hacen invisible para los ATS.'
}, {
  icon: MessageSquare,
  title: 'Plantillas de Mensajes en Frío',
  desc: 'Qué escribirle exactamente a un CEO o Recruiter para que te responda.'
}, {
  icon: DollarSign,
  title: 'Guía de Cobro Internacional',
  desc: 'Cómo traer tus dólares a casa con las comisiones más bajas del mercado.'
}, {
  icon: Globe2,
  title: 'Diccionario de Slang Corporativo',
  desc: 'Los términos en inglés que debes dominar en Zoom y Slack para sonar nativo.'
}];
export function WhatYouGet() {
  return <section className="py-24 px-4 bg-navy-900" data-id="element-168">
      <div className="max-w-5xl mx-auto" data-id="element-169">
        <FadeIn data-id="element-170">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-171">
            Lo que te llevas hoy
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-172">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-173">
                <div className="flex items-start gap-4 p-6 rounded-2xl bg-navy-800 border border-navy-600 hover:border-accent-500/30 transition-all group" data-id="element-174">
                  <div className="p-3 rounded-xl bg-navy-700 text-accent-400 group-hover:bg-accent-500/10 transition-colors" data-id="element-175">
                    <Icon className="w-6 h-6" data-id="element-176" />
                  </div>
                  <div data-id="element-177">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-178">
                      {item.title}
                    </h3>
                    <p className="text-slate-400" data-id="element-179">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}